import ApiProvider  from '../../../core/api/ApiProvider';
import { ActionStatusType } from '../../../core/types/ActionStatusType';

const DashboardApi = {
  getTabs: async <T>(): Promise<ActionStatusType<T>> => {
    return await ApiProvider.get<ActionStatusType<T>>(
      'TabsModule/GetTabs'
    );
  },
};

export default DashboardApi;
